import { render, staticRenderFns } from "./AllContents.vue?vue&type=template&id=c36a65f2"
import script from "./AllContents.vue?vue&type=script&lang=js"
export * from "./AllContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports